module.exports = __webpack_public_path__ + "static/img/car_4_2_cold@3x.76f42572.png";